<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { generateId } from '@client/utils/generate-id';

  export let domain = {};

  const {
    calendlyenabled,
    driftenabled,
    eloquaenabled,
    hubspotenabled,
    mauticenabled,
    munchkinenabled,
    outreachenabled,
    pardotenabled,
    rollworksenabled,
    salesloftenabled,
    zapierkey
  } = domain.domainsettings;

  const id = generateId();

  const integrations = [
    { name: 'Calendly', enabled: calendlyenabled },
    { name: 'Drift', enabled: driftenabled },
    { name: 'Eloqua', enabled: eloquaenabled },
    { name: 'HubSpot', enabled: hubspotenabled },
    { name: 'Mautic', enabled: mauticenabled },
    { name: 'Marketo', enabled: munchkinenabled },
    { name: 'Outreach', enabled: outreachenabled },
    { name: 'Pardot', enabled: pardotenabled },
    { name: 'RollWorks', enabled: rollworksenabled },
    { name: 'SalesLoft', enabled: salesloftenabled },
    { name: 'Zapier', enabled: zapierkey }
  ];

  $: hasIntegrations = integrations.some((integration) => integration.enabled);
</script>

{#if hasIntegrations}
  <div class="tag features" id="domain-integrations-{id}">
    <Icon name="zap" />
    {$format('label.INTEGRATIONS')}
    <Tooltip target="domain-integrations-{id}" placement="top">
      {#each integrations as integration}
        <ul>
          {#if integration.enabled}
            <li>{integration.name}</li>
          {/if}
        </ul>
      {/each}
    </Tooltip>
  </div>
{/if}

<style lang="scss" src="./integrations.scss"></style>
